"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginPropsWithIntl = void 0;
var _thirdPartyLogin = require("../constants/thirdPartyLogin");
var _messages = _interopRequireDefault(require("../messages"));
const getLoginPropsWithIntl = _ref => {
  let {
    thirdPartyLoginProps = {},
    intl
  } = _ref;
  if (!intl) return null;
  const {
    type,
    login,
    logout,
    ...rest
  } = thirdPartyLoginProps;
  if (type === _thirdPartyLogin.EHR_MYCHART) {
    return {
      ...rest,
      type,
      login: {
        ...login,
        header: intl.formatMessage(_messages.default.mychartLoginHeader),
        description: intl.formatMessage(_messages.default.mychartLoginDescription),
        action: intl.formatMessage(_messages.default.mychartLoginAction),
        separator: intl.formatMessage(_messages.default.mychartLoginSeparator)
      },
      logout: {
        ...logout,
        description: intl.formatMessage(_messages.default.mychartLogoutDescription),
        action: intl.formatMessage(_messages.default.mychartLogoutAction)
      }
    };
  }
  return null;
};
exports.getLoginPropsWithIntl = getLoginPropsWithIntl;